import { authManagementApi } from "@api";
import { sendSignin, sendSignup } from "@utils/antifraude";
import { push } from "connected-react-router";
import enums from "../enums";
import { sendSocketMessage, wsConnect } from "../middleware/middleware.js";
import APIS from "../service/api.js";
import Service from "../service/index.jsx";
import { getUser, removeUser, setUser } from "../utils";
import {
	getLastAuthTime,
	getSessionTimeout,
	setSessionTimeout as setStorageSessionTimeout,
	updateLastAuthTime as updateStorageLastAuthTime,
} from "../utils/authStorage";
import { getCurrentBalance } from "./balance";

export function checkValue({ name, value }) {
	return Service.get("auth-api", "checkUser", {
		params: {
			attributeName: name,
			attributeValue: value,
		},
	});
}
export function login(values, cb, errCb) {
	const { captchaToken, ...rest } = values;
	return (dispatch) => {
		dispatch({ type: enums.LOGIN_LOADING, payload: true });
		Service.post("auth-api", "login", rest, { headers: { "x-captcha-token": captchaToken } })
			.then((res) => {
				if (
					window.SUMSUB_VERIFICATION_INTERCEPTOR &&
					"message" in res.data &&
					"weblink" in res.data.message
				) {
					dispatch({ type: enums.LOGIN_LOADING, payload: false });
					return cb(res.data);
				}

				if (window.AUTH_SERVICE_V2) {
					if (res.data?.url) {
						const url = new URL(res.data.url);

						dispatch({
							type: enums.ALERT_IN,
							payload: {
								type: "info",
								msg: "LOGIN_REDIRECT",
								msgParams: { host: url.host },
								title: "INFO",
							},
						});
						setTimeout(() => {
							location.href = res.data.url;
						}, 1500);
					} else {
						let data = {
							username: values.Username,
							sessionId: "hiddensessionid",
							email: res.data.email || res.data.attributes?.email,
							national_id: res.data.national_id || res.data.attributes?.national_id,
							updateProfile: res.data.updateProfile || false,
						};
						dispatch({ type: enums.LOGIN_LOADING, payload: false });
						dispatch({ type: enums.LOGIN_SUCCESS, payload: data });

						if (res.data && res.data.updateProfile) {
							dispatch({ type: enums.PROFILE_UPDATE_REQUIRED, payload: true });
						}

						if (res.data && res.data.Authenticated) {
							setUser(data);
							sendSignin();
							setSessionTimeout(res.data.SessionTimeout);
							updateLastAuthTime();
							dispatch(
								wsConnect(
									`wss://${
										window.location.host.indexOf("localhost") > -1
											? APIS["base"]
											: window.location.host
									}${APIS["user-socket-api"]}`
								)
							);
							if (
								location.pathname.indexOf("sportsbook") > -1 ||
								location.pathname.indexOf("casino") > -1
							)
								location.reload();
						}
						cb(res.data);
					}
				} else {
					let data = {
						username: res.data.Username,
						sessionId: "hiddensessionid",
						email: res.data.email || res.data.attributes?.email,
						national_id: res.data.national_id || res.data.attributes?.national_id,
						updateProfile: res.data.updateProfile || false,
					};
					dispatch({ type: enums.LOGIN_LOADING, payload: false });
					dispatch({ type: enums.LOGIN_SUCCESS, payload: data });

					if (res.data && res.data.updateProfile) {
						dispatch({ type: enums.PROFILE_UPDATE_REQUIRED, payload: true });
					}

					//todo: get user profile
					if (res.data && res.data.Authenticated) {
						setUser(data);
						sendSignin();
						setNationalIdInMemory(
							res.data.national_id || res.data.attributes?.national_id
						);
						setSessionTimeout(res.data.SessionTimeout);
						updateLastAuthTime();
						dispatch(
							wsConnect(
								`wss://${
									window.location.host.indexOf("localhost") > -1
										? APIS["base"]
										: window.location.host
								}${APIS["user-socket-api"]}`
							)
						);
						if (
							location.pathname.indexOf("sportsbook") > -1 ||
							location.pathname.indexOf("casino") > -1
						)
							location.reload();
					}
					cb(res.data);
				}
			})
			.catch((e) => {
				dispatch({ type: enums.LOGIN_LOADING, payload: false });
				errCb(e);
				//alert("An error occured! Please try again.");
			});
	};
}

export function getUserNotifications() {
	return (dispatch) => {
		dispatch(sendSocketMessage({ action: "subscribe", data: "notifications" }));
	};
}

export function subscribeUserBalance() {
	return (dispatch) => {
		dispatch(sendSocketMessage({ action: "subscribe", data: "balance" }));
	};
}
export function respondToAuthChallenge(values, cb) {
	return (dispatch) => {
		dispatch({ type: enums.LOGIN_LOADING, payload: true });
		Service.post("auth-api", "respondToAuthChallenge ", values)
			.then((res) => {
				if (window.AUTH_SERVICE_V2 && res.data?.url) {
					const url = new URL(res.data.url);

					dispatch({
						type: enums.ALERT_IN,
						payload: {
							type: "info",
							msg: "LOGIN_REDIRECT",
							msgParams: { host: url.host },
							title: "INFO",
						},
					});
					setTimeout(() => {
						location.href = res.data.url;
					}, 1500);
				} else {
					let data = {
						username: res.data.Username,
						email: res.data.email || res.data.attributes?.email,
						national_id: res.data.national_id || res.data.attributes?.national_id,
						sessionId: "hiddensessionid",
					};
					dispatch({ type: enums.LOGIN_LOADING, payload: false });
					dispatch({ type: enums.LOGIN_SUCCESS, payload: data });
					//todo: get user profile
					if (res.data && res.data.Authenticated) {
						dispatch(
							wsConnect(
								`wss://${
									window.location.host.indexOf("localhost") > -1
										? APIS["base"]
										: window.location.host
								}${APIS["user-socket-api"]}`
							)
						);
					}
					setUser(data);
					sendSignin();
					setSessionTimeout(res.data?.SessionTimeout);
					updateLastAuthTime();
					cb();
				}
			})
			.catch((e) => {
				dispatch({ type: enums.LOGIN_LOADING, payload: false });
				removeUser();
				dispatch({
					type: enums.ALERT_IN,
					payload: {
						type: "error",
						msg: "GENERIC_ERROR",
						title: "ERROR",
					},
				});
				setTimeout(() => {
					location.reload();
				}, 400);
			});
	};
}

export function logout() {
	return (dispatch) => {
		dispatch({ type: enums.LOGIN_LOADING, payload: true });
		removeUser();
		window.dispatchEvent(new CustomEvent("userLogout"));
		Service.get("auth-api", "logout")
			.then((res) => {
				sendLogoutMsgToChildren();
				dispatch({ type: enums.LOGIN_LOADING, payload: false });
				dispatch({ type: enums.LOGOUT_SUCCESS, payload: false });
				dispatch(push("/"));
				setTimeout(() => {
					location.reload();
				}, 400);
			})
			.catch((e) => {
				//Cause a bug of backend, we accept user's session is expired
				sendLogoutMsgToChildren();
				dispatch({ type: enums.LOGIN_LOADING, payload: false });
				setTimeout(() => {
					location.reload();
				}, 400);
			});
	};
}

export function logoutElectrobets(url, token) {
	Service.create(
		"post",
		url,
		{},
		{
			headers: {
				"x-session-token": token,
			},
		}
	);
}

const sendLogoutMsgToChildren = () => {
	//get iframes belong to wisegaming.com
	let iframes = [...document.querySelectorAll("iframe")].filter(
		(f) => f.src.indexOf("wisegaming.com") > -1
	);
	iframes.forEach(
		(i) => i && i.contentWindow && i.contentWindow.postMessage({ cmd: "logout" }, "*")
	);
};

export function signup(user, cb, errCb) {
	const { captchaToken, ...rest } = user;
	const selectedCountryCode =
		rest?.UserAttributes?.find((attribute) => attribute?.Name === "custom:countryCode")
			?.Value || "";
	const isMarsTenant = window.TENANT?.includes("mars");
	const isBrazilSelected = selectedCountryCode.toUpperCase() === "BR";
	return (dispatch) => {
		dispatch({ type: enums.LOGIN_LOADING, payload: true });
		Service.post("auth-api", "signUp", rest, { headers: { "x-captcha-token": captchaToken } })
			.then((res) => {
				dispatch({ type: enums.LOGIN_LOADING, payload: false });
				sendSignup();
				cb(res.data);
			})
			.catch((e) => {
				dispatch({ type: enums.LOGIN_LOADING, payload: false });
				if (e.response && e.response.data) {
					const errorCode = e.response.data.code;
					const errorMessage = e.response.data.message || "";
					const isMarsBrazilLocationFallbackError =
						isMarsTenant &&
						isBrazilSelected &&
						(errorCode === "NAT_ID_NOT_PROVIDED" ||
							errorMessage === "Invalid national id.");
					dispatch({
						type: enums.ALERT_IN,
						payload: {
							type: "error",
							msg:
								errorCode && errorCode === "DuplicateNatIdException"
									? "NATIONAL_ID_ERROR"
									: isMarsBrazilLocationFallbackError
										? "SIGNUP_BRAZIL_IP_REQUIRED"
										: errorCode === "NAT_ID_NOT_PROVIDED" ||
											  errorMessage === "Invalid national id."
											? "INPUT_NATIONAL_ID_NOT_VALID"
										: errorCode === "UserLambdaValidationException"
										? "PRE_SIGNUP_ERROR"
										: errorCode === "UsernameOrEmailAlreadyInUse"
											? "USERNAME_OR_EMAIL_ALREADY_IN_USE"
											: errorMessage
												? errorMessage
												: "GENERIC_ERROR",
							title: "ERROR",
						},
					});
					errCb(e.response.data);
				} else {
					dispatch({
						type: enums.ALERT_IN,
						payload: {
							type: "error",
							msg: "GENERIC_ERROR",
							title: "ERROR",
						},
					});
				}
			});
	};
}

export function confirmSignUp(user, cb) {
	return (dispatch) => {
		dispatch({ type: enums.LOGIN_LOADING, payload: true });
		Service.post("auth-api", "confirmSignUp", user)
			.then((res) => {
				dispatch({ type: enums.LOGIN_LOADING, payload: false });
				cb(user, res.data);
			})
			.catch((e) => {
				dispatch({ type: enums.LOGIN_LOADING, payload: false });
				if (
					e.response &&
					e.response.data &&
					e.response.data.code === "AliasExistsException"
				) {
					dispatch({
						type: enums.ALERT_IN,
						payload: {
							type: "error",
							noTranslate: true,
							msg: e.response.data.message,
							title: "ERROR",
						},
					});
				} else {
					dispatch({
						type: enums.ALERT_IN,
						payload: {
							type: "error",
							msg: "GENERIC_ERROR",
							title: "ERROR",
						},
					});
				}
			});
	};
}
export function resendConfirmationCode(user, cb) {
	return (dispatch) => {
		dispatch({ type: enums.LOGIN_LOADING, payload: true });
		Service.post("auth-api", "resendConfirmationCode", user)
			.then((res) => {
				dispatch({ type: enums.LOGIN_LOADING, payload: false });
				cb(user, res.data);
			})
			.catch((e) => {
				dispatch({ type: enums.LOGIN_LOADING, payload: false });
				dispatch({
					type: enums.ALERT_IN,
					payload: {
						type: "error",
						msg: "GENERIC_ERROR",
						title: "ERROR",
					},
				});
			});
	};
}
export function forgotPassword(user, cb, rj) {
	const { captchaToken, ...rest } = user;
	return (dispatch) => {
		dispatch({ type: enums.LOGIN_LOADING, payload: true });
		Service.post("auth-api", "forgotPassword", rest, {
			headers: { "x-captcha-token": captchaToken },
		})
			.then((res) => {
				dispatch({ type: enums.LOGIN_LOADING, payload: false });
				cb(user, res.data);
			})
			.catch((e) => {
				dispatch({ type: enums.LOGIN_LOADING, payload: false });
				dispatch({
					type: enums.ALERT_IN,
					payload: {
						type: "error",
						msg: "GENERIC_ERROR",
						title: "ERROR",
					},
				});
			});
	};
}

export function forgotPasswordWithVerification(user, cb, rj) {
	const { captchaToken, ...rest } = user;
	return (dispatch) => {
		dispatch({ type: enums.LOGIN_LOADING, payload: true });
		Service.post("auth-api", "forgotPassword", rest, {
			headers: { "x-captcha-token": captchaToken },
		})
			.then((res) => {
				dispatch({ type: enums.LOGIN_LOADING, payload: false });
				cb(res.data);
			})
			.catch((e) => {
				dispatch({ type: enums.LOGIN_LOADING, payload: false });
				rj(e);
			});
	};
}

export function confirmForgotPassword(data, cb) {
	return (dispatch) => {
		dispatch({ type: enums.LOGIN_LOADING, payload: true });
		Service.post("auth-api", "confirmForgotPassword", data)
			.then((res) => {
				dispatch({ type: enums.LOGIN_LOADING, payload: false });
				cb(res.data);
			})
			.catch((e) => {
				dispatch({ type: enums.LOGIN_LOADING, payload: false });
				dispatch({
					type: enums.ALERT_IN,
					payload: {
						type: "error",
						msg: "GENERIC_ERROR",
						title: "ERROR",
					},
				});
			});
	};
}
export function enableMFA(cb, errCb) {
	return (dispatch) => {
		dispatch({ type: enums.PROFILE_LOADING, payload: true });
		Service.post("account-api", "enableMfa")
			.then((res) => {
				dispatch({ type: enums.PROFILE_LOADING, payload: res.data });
				if (cb) {
					cb(res);
				}
			})
			.catch((e) => {
				dispatch({ type: enums.PROFILE_LOADING, payload: false });
				errCb(e);
				console.log(e);
			});
	};
}

export function verifyMFAToken(params, cb) {
	return (dispatch) => {
		dispatch({ type: enums.INBOX_LOADING, payload: true });
		Service.post("account-api", "verifyMfaToken", params)
			.then((res) => {
				dispatch({ type: enums.INBOX_LOADING, payload: false });
				cb(res.data);
			})
			.catch((e) => {
				dispatch({ type: enums.INBOX_LOADING, payload: false });
				dispatch({
					type: enums.ALERT_IN,
					payload: {
						type: "error",
						msg: "CODE_MISMATCH",
						title: "ERROR",
					},
				});
			});
	};
}
export function disableMfa(cb) {
	return (dispatch) => {
		dispatch({ type: enums.INBOX_LOADING, payload: true });
		Service.post("account-api", "disableMfa")
			.then((res) => {
				dispatch({ type: enums.INBOX_LOADING, payload: false });
				cb(res.data);
			})
			.catch((e) => {
				dispatch({ type: enums.LOGIN_LOADING, payload: false });
				dispatch({
					type: enums.ALERT_IN,
					payload: {
						type: "error",
						msg: "Not disabled MFA",
						title: "ERROR",
					},
				});
			});
	};
}

export function selfExclusion(values, cb) {
	return (dispatch) => {
		dispatch({ type: enums.PROFILE_LOADING, payload: true });
		Service.post(
			"account-api",
			"selfexclusion?isSelfExcluded=true&selfExculsionDays=" + values.selfExculsionDays
		)
			.then((res) => {
				cb(res.data);
				dispatch({
					type: enums.ALERT_IN,
					payload: {
						type: "error",
						msg: "Self exclusion Success",
						title: "SUCCESS",
					},
				});
			})
			.catch((e) => {
				dispatch({
					type: enums.ALERT_IN,
					payload: {
						type: "error",
						msg: "Not working self exclusion",
						title: "ERROR",
					},
				});
			})
			.finally(() => {
				dispatch({ type: enums.PROFILE_LOADING, payload: true });
			});
	};
}

// export function selfExternalProfileInfo(cb) {
// 	return (dispatch) => {
// 		dispatch({ type: enums.PROFILE_LOADING, payload: true });
// 		Service.get("account-api", "extprofile")
// 			.then((res) => {
// 				cb(res.data);
// 			})
// 			.catch((e) => {})
// 			.finally(() => {
// 				dispatch({ type: enums.PROFILE_LOADING, payload: true });
// 			});
// 	};
// }

export function checkCurrencyAvailability(countryCode) {
	return Service.get("auth-api", "currencies", {
		params: {
			countryCode: countryCode.toLowerCase(),
		},
	});
}

export function getProfile() {
	return (dispatch) => {};
}

//TODO: remove
export function loginSuccess(user) {
	return (dispatch) => {
		dispatch({ type: enums.LOGIN_SUCCESS, payload: user });
		//tenant will be dynamic
		dispatch(getCurrentBalance("UZjlwDyeV", user.attributes.sub));
	};
}

//TODO: remove
export function logoutSuccess(user) {
	return (dispatch) => {
		dispatch({ type: enums.BALANCE_UPDATED, payload: {} });
		dispatch({ type: enums.LOGOUT_SUCCESS, payload: user });
		dispatch(clearUserSession());
	};
}
//TODO: remove
export function clearUserSession() {
	localStorage.removeItem("user_data");
	localStorage.removeItem("currency");
}

export function reAuthenticate(usernameParam) {
	return (dispatch) => {
		const user = getUser();
		if (!user || !user.sessionId || !(user.username || usernameParam)) {
			return;
		}
		const username = usernameParam || user.username;
		dispatch(authManagementApi.endpoints.reAuth.initiate(username));
	};
}

export const setSessionTimeout = setStorageSessionTimeout;
export const updateLastAuthTime = updateStorageLastAuthTime;

export function checkAndReAuth(dispatch) {
	const user = getUser();
	if (!user || !user.sessionId) {
		return;
	}

	const timeout = getSessionTimeout();
	const lastAuth = getLastAuthTime();

	const thresholdMs = timeout * 1000 * 0.2;
	const elapsed = Date.now() - lastAuth;

	console.log(
		`[re-auth] elapsed: ${Math.round(elapsed / 1000)}s / threshold: ${Math.round(
			thresholdMs / 1000
		)}s`
	);

	if (!lastAuth || elapsed >= thresholdMs) {
		dispatch(reAuthenticate());
	}
}
